/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, June 2023
 * @flow
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { Close as CloseIcon } from '@material-ui/icons';
import { Box, Grid, Typography, Dialog, DialogContent, DialogTitle, IconButton, Icon } from '@material-ui/core';
import cn from 'classnames';
import useStyles from './useStyles';

const HelpPopup = ({ open, onClose }) => {
  const { labelsData } = useSelector(state => state);
  const labels = labelsData?.labels;
  const classes = useStyles();

  const Help = [
    { label: labels.HELP_POPUP_ASSIGN, icon: 'send' },
    { label: labels.HELP_POPUP_VOID_CHECK, icon: 'playlist_remove' },
    { label: labels.HELP_POPUP_RETURN_TO_WAITLIST, icon: 'keyboard_return' },
    { label: labels.HELP_POPUP_UNMERGE_TABLE, icon: 'call_split' },
    { label: labels.HELP_POPUP_EDIT_WAITLIST, icon: 'edit' },
    { label: labels.HELP_POPUP_CLEAR_TABLE, icon: 'table_restaurant' },
    { label: labels.HELP_POPUP_DELETE_WAITLIST, icon: 'delete' },
    { label: labels.HELP_POPUP_TRANSFER_TABLE, icon: 'sync_alt' },
    { label: labels.HELP_POPUP_SMS_GUEST, icon: 'sms' },
    { label: labels.HELP_POPUP_MERGE_TABLE, icon: 'merge_type' },
    { label: labels.HELP_POPUP_REORDER_WAITLIST, icon: 'swap_vert' },
  ];

  return (
    <Dialog
      open={open}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
      PaperProps={{
        style: {
          minHeight: '48%',
          minWidth: '40%',
        }
      }}
    >
      <DialogTitle id="dialog-title" className={classes.dialogTitleContainer} disableTypography>
        <Typography variant="body1" className={classes.dialogTitle}>{labels.HELP_POPUP_HELP}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      <DialogContent>
        <Grid container>
          {Help.map(help =>
            <Grid item key={help.label} xs={12} sm={6} md={6} lg={6}>
              <Box display={'flex'} alignItems={'center'} mb={1} mt={1}>
                <Icon fontSize='small' className={cn('material-icons-outlined', classes.icon)}>{help.icon}</Icon>
                <Typography variant='body2' className={classes.valueTxt}>{help.label}</Typography>
              </Box>
            </Grid>
          )}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default HelpPopup;
